module.exports = __webpack_public_path__ + "img/docker.d0440b6a.png";